module.exports = __webpack_public_path__ + "img/dialog-img-03.c4a7ed0b.png";